var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useReducer, useState } from "react";
import { useLocale } from "../../communication";
import { getConfig } from "../../services/mp-config";
import { Loader } from '../Loader/Loader';
import Notification from "../Notification/Notification";
import { useSteps } from "../../hooks/useSteps";
import StepSwitcher from "../StepSwitcher/StepSwitcher";
import { AppPropsContext } from "../../hooks/AppPropsContext";
import { ConfigContext } from "../../hooks/ConfigContext";
import { StepContext } from "../../hooks/StepContext";
import { SchedulerDataContext } from "../../hooks/SchedulerDataContext";
import { MessageContext } from "../../hooks/MessageContext";
import { OrderContext } from "../../hooks/OrderContext";
import { ThemeProvider } from "@mui/material";
import { Theme } from '../../styles/MuiThemeOverride';
import StepProgress from "../StepProgress/StepProgress";
import Icon from "../Icon/Icon";
import { t } from '@mp/locale';
import Button from '../../button';
import { LoadingContext } from "../../hooks/LoadingContext";
import { getOrder, setApiRoot, setOrderId, } from "../../services/schedulerService";
import Sidebar from "../Sidebar/Sidebar";
function reducer(state, action) {
    var _a;
    return __assign(__assign({}, state), (_a = {}, _a[action.step] = action.data, _a));
}
export default function CsScheduler(props) {
    useLocale();
    var _a = useState(null), config = _a[0], setConfig = _a[1];
    var _b = useState(false), configLoaded = _b[0], setConfigLoaded = _b[1];
    var _c = useReducer(reducer, {}), schedulerData = _c[0], setSchedulerData = _c[1];
    var _d = useState(), order = _d[0], setOrder = _d[1];
    var _e = useState(""), message = _e[0], setMessage = _e[1];
    var _f = useState(""), loadingMessage = _f[0], setLoadingMessage = _f[1];
    var steps = useSteps();
    var _g = useState(false), isLoading = _g[0], setIsLoading = _g[1];
    useEffect(function () {
        setIsLoading(true);
        getConfig()
            .then(function (data) {
            setApiRoot(data === null || data === void 0 ? void 0 : data.captureSvcsRoot);
            setConfig(data["capture-services"]);
            setConfigLoaded(true);
        })
            .catch(function (error) {
            var _a, _b;
            setLoadingMessage(((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) ||
                t("CAPTURE_SERVICES.ORDER.NOTIFICATIONS.unexpectedError"));
        })
            .finally(function () {
            setIsLoading(false);
        });
    }, []);
    useEffect(function () {
        if (message) {
            setTimeout(function () {
                setMessage("");
            }, 3000);
        }
    }, [message]);
    useEffect(function () {
        if (configLoaded && props.preOrderId) {
            setOrderId(props.preOrderId);
            getOrder().then(function (data) {
                var _a, _b;
                setOrder(data);
                setSchedulerData({
                    step: "property_details",
                    data: __assign(__assign({}, data.address), { addressString: {
                            description: (_a = data === null || data === void 0 ? void 0 : data.address) === null || _a === void 0 ? void 0 : _a.address_string,
                            placeid: (_b = data === null || data === void 0 ? void 0 : data.address) === null || _b === void 0 ? void 0 : _b.place_id,
                        }, property_type: data.property_type, spaces: data.spaces }),
                });
                if (data.preferred_start_time) {
                    setSchedulerData({
                        step: "scheduler",
                        data: {
                            preferred_start_time: new Date(data.preferred_start_time),
                        },
                    });
                }
                setSchedulerData({
                    step: "contact",
                    data: {
                        isUser: true,
                        contact_email: data.contact_email || "",
                        contact_name: data.contact_name || "",
                        contact_phone: data.contact_phone || "",
                        contact_will_be_onsite: typeof data.contact_will_be_onsite === "undefined"
                            ? true
                            : data.contact_will_be_onsite,
                        special_requests: data.special_requests || "",
                    },
                });
            });
        }
    }, [configLoaded, props.preOrderId]);
    if (!configLoaded) {
        return (_jsx(_Fragment, { children: _jsx(Notification, { alertType: "error", content: loadingMessage, visible: !!loadingMessage, onClose: function () { return setLoadingMessage(""); } }) }));
    }
    return (_jsx(AppPropsContext.Provider, __assign({ value: props }, { children: _jsx(ConfigContext.Provider, __assign({ value: config }, { children: _jsx(LoadingContext.Provider, __assign({ value: { isLoading: isLoading, setIsLoading: setIsLoading } }, { children: _jsx(StepContext.Provider, __assign({ value: steps }, { children: _jsx(SchedulerDataContext.Provider, __assign({ value: { schedulerData: schedulerData, setSchedulerData: setSchedulerData } }, { children: _jsx(OrderContext.Provider, __assign({ value: { order: order, setOrder: setOrder } }, { children: _jsxs(MessageContext.Provider, __assign({ value: { setMessage: setMessage } }, { children: [_jsx(Notification, { alertType: "error", action: "close", content: message, visible: !!message, onClose: function () { return setMessage(""); } }), _jsx(ThemeProvider, __assign({ theme: Theme }, { children: _jsxs("div", __assign({ className: "mp-capturesvc-step-order-container" }, { children: [_jsxs("div", __assign({ className: "mp-capturesvc-step-container" }, { children: [_jsxs("div", __assign({ className: "mp-capturesvc-step-container-topbar" }, { children: [props.onCloseButtonClicked && (_jsx(Button, __assign({ label: "", htmlId: "closeButton", ariaLabel: t("CAPTURE_SERVICES.ORDER.ACTIONS.returnToDashboard"), className: "mp-capturesvc-exit", onClick: function () {
                                                                        return props.onCloseButtonClicked(steps.step, steps.steps);
                                                                    }, buttonType: "link", type: "button" }, { children: _jsx(Icon, { icon: "ico-close", title: t("CAPTURE_SERVICES.ORDER.ACTIONS.returnToDashboard") }) }))), _jsx(StepProgress, {})] })), _jsx("div", __assign({ className: "mp-capturesvc-step-container-content" }, { children: _jsx(StepSwitcher, {}) })), props.showSidebar && _jsx(Sidebar, {})] })), isLoading && _jsx(Loader, { loaderType: "bounce" })] })) }))] })) })) })) })) })) })) })));
}
